<perfect-scrollbar class="page-sidebar-wrapper" id="main-menu-wrapper" wheel-propagation="true" suppress-scroll-x="true"
  min-scrollbar-length="20" menuheight>
  <div class="profile-info" ng-show="app.settings.menuProfile">
    <div class="profile-image col-md-12 col-sm-12 col-xs-12 text-center">
      <a ui-sref="app.hos-doctor-profile">
        <img src="../../../assets/images/user.png" class="img-responsive">
        <!-- <span class="profile-status available"></span> -->
      </a>
    </div>
    <div class="profile-details col-md-12 col-sm-12 col-xs-12 margin-top-5" *ngIf="userInfo">
      <h3>
        <a ui-sref="app.ui.profile">{{userInfo.userName}}</a>
      </h3>
      <p class="profile-title" style="text-transform: uppercase;">{{getRoleName(userInfo.userRole)}}</p>
    </div>
  </div>

  <ul class="wraplist wrapper-menu">
    <li (click)="markNewActiveMenu('spectacleHome')" [ngClass]="{active: menuList.spectacleHome}">
      <a title="Spectacle Management" href="javascript:;" (click)="navigateToTemplate('/spectacle/home')"
        class="nosub navlink">
        <i class="fa fa-cogs" style="font-size: 22px;"></i>
        <span class="title" style="position: absolute;">Spectacle Vendors</span>
      </a>
    </li>
  </ul>

  <div style="padding-bottom: 5px;">
    <button style="color:white;border-radius: 0px;padding: 5px;font-size: medium;" class="btn btn-block teleye-button"
      (click)="showTelecareMenu=true;showDHPMenu=false;markNewActiveMenu('telecareDashboard');navigateToTemplate('/telecareDashboard')"
      [ngClass]="{'btn-warning':showTelecareMenu == true,'inactive-menu-header':showTelecareMenu == false}"
      id="teMenu">TE</button>
    <button style="color:white;border-radius: 0px;padding: 5px;font-size: medium;" class="btn btn-block dhp-button"
      (click)="showTelecareMenu=false;showDHPMenu=true;markNewActiveMenu('dashboard');navigateToTemplate('/dashboard')"
      [ngClass]="{'btn-warning':showDHPMenu == true,'inactive-menu-header':showDHPMenu == false}"
      id="dhpMenu">DHP</button>
  </div>

  <ul class="wraplist wrapper-menu" #wrappermenu *ngIf="showDHPMenu==true" style="margin-top:20px ;">
    <!--<ul class="wraplist wrapper-menu" #wrappermenu>-->
    <!-- <li (click)="markNewActiveMenu('dashboard')" [ngClass]="{active: menuList.dashboard}">
      <a href="javascript:;" (click)="navigateToTemplate('/dashboard')" class="nosub navlink">
        <i class="fa fa-tachometer" tooltip="Dashboard" style="font-size: 22px;"></i>
        <span class="title" style="position: absolute;">Dashboard</span>
      </a>
    </li> -->
    <li (click)="markNewActiveMenu('accounts')" [ngClass]="{active: menuList.accounts}">
      <a href="javascript:;" (click)="navigateToTemplate('/accounts')" class="nosub navlink">
        <i class="material-icons" tooltip="Accounts">account_circle</i>
        <span class="title">Accounts</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('serviceProviders')" [ngClass]="{active: menuList.serviceProviders}">
      <a href="javascript:;" (click)="navigateToTemplate('/service-providers')" class="nosub navlink">
        <i class="material-icons" tooltip="Service Providers">group</i>
        <span class="title">Service Providers</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('adminUsers')" [ngClass]="{active: menuList.adminUsers}">
      <a href="javascript:;" (click)="navigateToTemplate('/admin-users')" class="nosub navlink">
        <i class="material-icons" tooltip="Admin Users">group_add</i>
        <span class="title">Admin Users</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('workflowSettings')" [ngClass]="{active: menuList.workflowSettings}">
      <a href="javascript:;" (click)="navigateToTemplate('/workflow-customization')" class="nosub navlink">
        <i class="fa  fa-cogs" tooltip="Workflow Settings"></i>
        <span class="title" style="vertical-align: baseline;">Workflow Settings</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('devices')" [ngClass]="{active: menuList.devices}">
      <a href="javascript:;" (click)="navigateToTemplate('/devices')" class="nosub navlink">
        <i class="fa fa-laptop" tooltip="Devices"></i>
        <span class="title" style="vertical-align: baseline;">Devices</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('frameworkSettings')" [ngClass]="{active: menuList.frameworkSettings}">
      <a href="javascript:;" (click)="navigateToTemplate('/framework-settings')" class="nosub navlink">
        <i class="fa  fa-cubes" tooltip="Framework Settings"></i>
        <span class="title" style="vertical-align: baseline;">Framework Config</span>
      </a>
    </li>

    <!-- Screenings Sidebar Start -->

    <li (click)="markNewActiveMenu('screeningEvents')" [ngClass]="{active: menuList.screeningEvents}">
      <a href="javascript:;" (click)="navigateToTemplate('/screening-events')" class="nosub navlink">
        <i class="fa fa-user-md" aria-hidden="true"></i>
        <span class="title" style="vertical-align: baseline;">Screening Events</span>
      </a>
    </li>

    <!-- Screenings Sidebar Ends -->

    <!-- Appointment Sidebar Start -->

    <li (click)="markNewActiveMenu('appointments')" [ngClass]="{active: menuList.appointments}">
      <a href="javascript:;" (click)="navigateToTemplate('/appointments')" class="nosub navlink">
        <i class="fa fa-calendar-o" aria-hidden="true"></i>
        <span class="title" style="vertical-align: baseline;">Appointments</span>
      </a>
    </li>

    <!-- Appointment Sidebar Ends -->

    <li (click)="markNewActiveMenu('fieldCustomization')" [ngClass]="{active: menuList.fieldCustomization}">
      <a href="javascript:;" (click)="navigateToTemplate('/field-customization')" class="nosub navlink">
        <i class="fa  fa-edit" tooltip="Field Customization"></i>
        <span class="title" style="vertical-align: baseline;">Field Customization</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('exportExcel')" [ngClass]="{active: menuList.exportExcel}">
      <a href="javascript:;" (click)="navigateToTemplate('/export-excel')" class="nosub navlink">
        <i class="fa  fa-file-excel-o" tooltip="Export bulk patient Excel"></i>
        <span class="title" style="vertical-align: baseline;">Export Excel</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('icdCodes')" [ngClass]="{active: menuList.icdCodes}">
      <a href="javascript:;" (click)="navigateToTemplate('/configurations')" class="nosub navlink">
        <i class="fa fa-cog" tooltip="ICD Codes"></i>
        <span class="title" style="vertical-align: baseline;">ICD Codes</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('apiKeys')" [ngClass]="{active: menuList.apiKeys}">
      <a href="javascript:;" (click)="navigateToTemplate('/api-keys')" class="nosub navlink">
        <i class="fa fa-key" tooltip="API Keys"></i>
        <span class="title" style="vertical-align: baseline;">API Keys</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('providerConfigurations')" [ngClass]="{active: menuList.providerConfigurations}">
      <a href="javascript:;" (click)="navigateToTemplate('/providerConfigurations')" class="nosub navlink">
        <i class="fa fa-life-ring" tooltip="Provider Configuration"></i>
        <span class="title" style="vertical-align: baseline;">Configuration</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('priceConfiguration')" [ngClass]="{active: menuList.priceConfiguration}">
      <a href="javascript:;" (click)="navigateToTemplate('/payment-subscription')" class="nosub navlink">
        <i class="fa fa-inr" tooltip="Price Configuration"></i>
        <span class="title" style="vertical-align: baseline;">Price Configuration</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('offlinePayment')" [ngClass]="{active: menuList.offlinePayment}">
      <a href="javascript:;" (click)="navigateToTemplate('/offline-payment')" class="nosub navlink">
        <i class="fa fa-money" tooltip="Offline Payment"></i>
        <span class="title" style="vertical-align: baseline;">Offline Payments</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('packages')" [ngClass]="{active: menuList.packages}">
      <a href="javascript:;" (click)="navigateToTemplate('/packages')" class="nosub navlink">
        <i class="fa  fa-suitcase" tooltip="Packages"></i>
        <span class="title" style="vertical-align: baseline;">Packages</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('packagesValidity')" [ngClass]="{active: menuList.packagesValidity}">
      <a href="javascript:;" (click)="navigateToTemplate('/packages-validity')" class="nosub navlink">
        <i class="fa fa-calendar-times-o" tooltip="Packages Validity"></i>
        <span class="title" style="vertical-align: baseline;">Packages Validity</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('validityExtension')" [ngClass]="{active: menuList.validityExtension}">
      <a href="javascript:;" (click)="navigateToTemplate('/validity-extension')" class="nosub navlink">
        <i class="fa fa-calendar" tooltip="Validity Extension"></i>
        <span class="title" style="vertical-align: baseline;">Validity Extension</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('transactionHistory')" [ngClass]="{active: menuList.transactionHistory}">
      <a href="javascript:;" (click)="navigateToTemplate('/tshistory')" class="nosub navlink">
        <i class="fa fa-history" tooltip="Transaction History"></i>
        <span class="title" style="vertical-align: baseline;">Transaction History</span>
      </a>
    </li>
    <!-- <li (click)="markNewActiveMenu('paymentStatistics')" [ngClass]="{active: menuList.paymentStatistics}">
      <a href="javascript:;" class="nosub navlink">
        <i class="fa fa-line-chart" tooltip="Payment Statistics"></i>
        <span class="title" style="vertical-align: baseline;">Payment Statistics</span>
      </a>
    </li> -->
    <li (click)="markNewActiveMenu('incentiveConfig')" [ngClass]="{active: menuList.incentiveConfig}">
      <a href="javascript:;" (click)="navigateToTemplate('/incentive_config')" class="nosub navlink">
        <i class="fa fa-gift" tooltip="Account Incentive Config"></i>
        <span class="title" style="vertical-align: baseline;">Incentive Config</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('incentiveReport')" [ngClass]="{active: menuList.incentiveReport}">
      <a href="javascript:;" (click)="navigateToTemplate('/incentive_report')" class="nosub navlink">
        <i class="fa fa-money" tooltip="User Incentives Report"></i>
        <span class="title" style="vertical-align: baseline;">Incentives Report</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('visitConfig')" [ngClass]="{active: menuList.visitConfig}">
      <a href="javascript:;" (click)="navigateToTemplate('/visit-config')" class="nosub navlink">
        <i class="fa fa-sun-o" tooltip="Refraction Configuration"></i>
        <span class="title" style="vertical-align: baseline;">Visit Config</span>
      </a>
    </li>
    <!--<li (click)="markNewActiveMenu('labelConfig')" [ngClass]="{active: menuList.labelConfig}">
      <a title="Label Config" href="javascript:;" (click)="navigateToTemplate('/labelConfig')"
        class="nosub navlink">
        <i class="fa fa-font"></i>
        <span class="title" style="vertical-align: baseline;">Label Config</span>
      </a>
    </li>-->
    <!-- (click)="navigateToTemplate('/payment-statistics')" -->
    <!--<li>
      <a href="javascript:;" (click)="navigateToTemplate($event,'/payment-subscription')" class="nosub navlink">
        <i class="fa  fa-credit-card"></i>
        <span class="title" style="vertical-align: baseline;">Payment Config</span>
      </a>
    </li>-->

    <!-- <li href class="auto menulist" #submenu1>
      <a href="javascript:;" class="navlink" (click)="expandList($event)">
        <i class="material-icons">person_add</i>
        <span class="title">Doctors</span>
        <span class="arrow material-icons" *ngIf="!submenu1.classList.contains('active')">keyboard_arrow_right</span>
        <span class="arrow material-icons open" *ngIf="submenu1.classList.contains('active')">keyboard_arrow_down</span>
      <a href="javascript:;" (click)="navigateToTemplate($event,'/payment-subscription')" class="nosub navlink">
        <i class="fa fa-inr"></i>
        <span class="title" style="vertical-align: baseline;">Price Configuration</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" (click)="navigateToTemplate($event,'/packages')" class="nosub navlink">
        <i class="fa  fa-suitcase"></i>
        <span class="title" style="vertical-align: baseline;">Packages</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" (click)="navigateToTemplate($event,'/validity-extension')" class="nosub navlink">
        <i class="fa fa-calendar"></i>
        <span class="title" style="vertical-align: baseline;">Validity Extension</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" (click)="navigateToTemplate($event,'/tshistory')" class="nosub navlink">
        <i class="fa fa-history"></i>
        <span class="title" style="vertical-align: baseline;">Transaction History</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" (click)="navigateToTemplate($event,'/payment-statistics')" class="nosub navlink">
        <i class="fa fa-line-chart"></i>
        <span class="title" style="vertical-align: baseline;">Payment Statistics</span>
      </a>
    </li>
    <!-- <div class="col-md-12 version-no"
      style="position: fixed !important;bottom:0px !important;color:#b0bec5;margin-bottom:10px;margin-left: 25px;font-size: 13px;">
      Version v2.1.0
    </div>
    <div class="col-md-12 version-no-collapsed"
      style="position: fixed !important;bottom:0px !important;color:#b0bec5;margin-bottom:10px;padding-left: 7px;font-size: 13px;display:none;">
      v2.1.0
    </div> -->
  </ul>
  <ul class="wraplist wrapper-menu" #wrappermenu *ngIf="showTelecareMenu==true">
    <li (click)="markNewActiveMenu('telecareDashboard')" [ngClass]="{active: menuList.telecareDashboard}">
      <a href="javascript:;" (click)="navigateToTemplate('/telecareDashboard')" class="nosub navlink">
        <i class="fa fa-tachometer" style="font-size: 22px;" tooltip="Telecare Dashboard"></i>
        <span class="title" style="position: absolute;">Dashboard</span>
      </a>
    </li>
    <li (click)="markNewActiveMenu('frameworkSettingsTeleeye')" [ngClass]="{active: menuList.frameworkSettingsTeleeye}">
      <a href="javascript:;" (click)="navigateToTemplate('/framework-settings-teleeye')" class="nosub navlink">
        <i class="fa  fa-cubes" tooltip="Framework Settings"></i>
        <span class="title" style="vertical-align: baseline;">Framework Config</span>
      </a>
    </li>
  </ul>
</perfect-scrollbar>